import * as React from 'react';
import pick from 'lodash/pick';
import { useField } from 'react-final-form';
import { ToggleGroup, TogglePill } from '@gandi/ui';
import { groupPropKeys } from '../decorateControl';
import { FinalFormGroup } from './FinalFormGroup';
import { jsx as _jsx } from "react/jsx-runtime";
export function TogglePillField({
  children,
  name,
  value,
  ...togglePillProps
}) {
  const {
    input
    // $FlowFixMe[prop-missing] FinalForm's UseFieldConfig definition isn't compatible with exact_by_default
  } = useField(name, {
    type: 'radio',
    value
  });
  return /*#__PURE__*/_jsx(TogglePill, {
    ...togglePillProps,
    ...input,
    type: "radio",
    children: children
  });
}
/**
 * USAGE:
 * ```
 *   <ToggleFieldGroup name="field_name">
 *     <TogglePillField value="first_pill" id="something-1">First</TogglePillField>
 *     <TogglePillField value="second_pill" id="something-2">Second</TogglePillField>
 *   </ToggleFieldGroup>
 * ````
 */
export function ToggleFieldGroup(props) {
  const {
    name,
    value,
    validate,
    ...toggleProps
  } = props;
  const groupProps = pick(props, groupPropKeys);
  useField(name,
  // $FlowFixMe[prop-missing] FinalForm's UseFieldConfig definition isn't compatible with exact_by_default
  {
    validate,
    subscription: {}
  });
  return /*#__PURE__*/_jsx(FinalFormGroup, {
    name: name,
    ...groupProps,
    children: /*#__PURE__*/_jsx(ToggleGroup, {
      name: name,
      ...toggleProps
    })
  });
}